<div
  class="bg"
  style="display: flex; flex-direction: column; align-items: center"
>
  <!--Adding-->

  <!---<div style="display: flex; margin-top: 10px;">
        <input type="text" placeholder="First Name" style="margin-right: 10px;">
        <input type="text" placeholder="Last Name" style="margin-right: 10px;">
        <input type="date">
    </div>-->

  <!--Table Data-->
  <div style="padding-top: 15px">
    <hr style="width: 80%; margin-top: 10px; margin-bottom: 10px" />
  </div>
  <!-- tableau -->
<!-- Single alumni -->
<div *ngIf="alumni">
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Full name</th>
        <td>{{ alumni.nom }} {{ alumni.prenom }}</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th scope="row">Email</th>
        <td>{{ alumni.email }}</td>
      </tr>
      <tr>
        <th scope="row">Phone</th>
        <td>{{ alumni.tel }}</td>
      </tr>
      <tr>
        <th scope="row">Gender</th>
        <td>{{ alumni.sex }}</td>
      </tr>
      <tr>
        <th scope="row">Mission</th>
        <td>{{ alumni.departement }}</td>
      </tr>
      <tr>
        <th scope="row">Mandat</th>
        <td>{{ alumni.session }}</td>
      </tr>
      <tr>
        <th scope="row">Awards</th>
        <td>{{ alumni.awards }}</td>
      </tr>
    </tbody>
  </table>
</div>
<div *ngIf="alumni?.length > 1">
  <table class="table">
    <tbody>
      <tr *ngFor="let al of alumni">
        <td>
          <div class="name-column">
            <img
              class="profile-photo"
              src="http://localhost:9091/User/{{ al.coverImage }}"
              alt="Med Ali Jlassi"
            />
            {{ al.nom }} {{ al.prenom }}
          </div>
        </td>
        <td>Male</td>
        <td>{{ al.departement }}</td>
        <td>{{ al.session }} <i class="fas fa-edit edit-icon"></i></td>
      </tr>
    </tbody>
  </table>
</div><div *ngIf="alumni?.length > 1">
  <table class="table">
    <tbody>
      <tr *ngFor="let al of alumni">
        <td>
          <div class="name-column">
            <img
              class="profile-photo"
              src="http://localhost:9091/User/{{ al.coverImage }}"
              alt="Med Ali Jlassi"
            />
            {{ al.nom }} {{ al.prenom }}
          </div>
        </td>
        <td>Male</td>
        <td>{{ al.departement }}</td>
        <td>{{ al.session }} <i class="fas fa-edit edit-icon"></i></td>
      </tr>
    </tbody>
  </table>
</div>

  <!-- Add Alumni Modal -->

  <!-- Update Alumni Modal -->
</div>
